module.exports =  {
  hotel: {
    BOOKING_NOW: '今すぐ予約',
    Book_Hotel: 'ホテル予約',
    Select_your_destination: '目的地をご選択ください',
    Please_enter_your_destination: '目的地/ホテルをご入力ください',
    Booked_up: '既に売り切れました',
    Hotel_description: 'ホテル紹介',
    Check_in_date: 'チェックイン日付',
    Check_out_date: 'チェックアウト日付',
    Sold_out: '売り切れ',
    Non_refundable: '取消できません',
    reserve: '予約',
    Pay_Online: 'Pay online',
    Only_rooms_left_before: '',
    Only_rooms_left_after: '客室残り',
    Cancellation_Policy: 'キャンセルルール',
    See_all_prices_before: '全ての',
    See_all_prices_after: 'つ価格を見ます',
    Estimated_time_of_arrival: '着店見込み',
    make_your_schedule_well_planned: '地元日時。選択したら、合理的に出行手配します',
    Hotel_Not_Found: '条件に合致するホテルがありません',
    Please_change_your_search: '条件を改めして再びご検索ください',
    Submit_an_application: '申請を提出します',
    Hotel_Confirmation: 'ホテル確認',
    Many_Night_Stay_before: '',
    Many_Night_Stay_after: '泊泊ります',
    Hotel_Booking_Number: 'ホテル予約番号',
    Online_Payment: 'オンラインペイ',
    The_guest_Room_before: '宿泊する人',
    The_guest_Room_after: '」',
    Contact_number: '電話番号',
    Bring_all_valid_IDs: 'ご宿泊する時、宿泊する人の身分証明書をご提供ください。',
    Hotels_Found_before: '',
    Hotels_Found_after: 'ヶ所ホテルを検索しました',
    Hotels_Presented_before: '当前',
    Hotels_Presented_center: 'ヶ所ホテルを示します（合計',
    Hotels_Presented_after: 'ヶ所）',
    Please_change_the_dates: '選択日時の房型がありません、再び宿泊日時をご選択ください',
    Login: '预订酒店需要登录app',
    Nights_in_total_before: '共に',
    Nights_in_total_after: '泊',
    Location: 'ホテル場所',
    Pictures: 'ホテルの写真',
    Description: 'ホテル紹介',
    Policy: 'ホテルの政策',
    Check_in_and_check_out_time: '出入り日時',
    Check_in_and_Check_out_before: 'チェックイン時間：',
    Check_in_and_Check_out_center: '時以後 チェックアウト時間：',
    Check_in_and_Check_out_after: '時前',
    Check_in_time: 'チェックイン時間',
    Check_out_time: 'チェックアウト時間',
    Hotel_Information: '基本情報',
    Opening_Date: '開業日',
    Renovation_Date: '改装日',
    Facility_Service: '施設サービス',
    Payment_methods: 'ホテルが受け取る支払い方法',
    Hotel_Address: 'ホテル場所',
    Pay_online: 'オンラインペイ',
    Pay_offline: 'フライン決済',
    Night_stay_before: '',
    Night_stay_after: '泊宿泊し、',
    Rooms_total_before: '客室は合計',
    Rooms_total_after: '元です',
    Guest_name_must_be_provided: '宿泊する人の全名をご記入ください',
    Please_fill_in_your_contact_number: '電話番号をご入力ください',
    Select_estimated_time_of_arrival: '着店見込み日時をご選択ください',
    Number_of_Rooms: '客室の数',
    Maximum_guests_per_room_before: '1室に最大',
    Maximum_guests_per_room_after: '人宿泊できます',
    Many_Rooms: '客室',
    Service_Fee_Included: '税込みとサービス費',
    Last_Name: '姓のピンイン',
    First_Name: '名字のピンイン',
    Room: '客室',
    Additional_Tax: '税金',
    Please_inform_the_hotel: 'もし遅刻する場合、早めにご連絡ください',
    Please_inform_the_hotel_first: '早めにホテルに連絡ありませんため、遅刻する場合、多分部屋と夕食の手配に関係あります。事前にご確認ください',
    Booking_Cancellation: '予約を取消',
    Reason_of_Cancellation: '予約を取消',
    Incorrect_Information_Filled: '情報入力が間違います',
    Itinerary_Changed: '行程が変わります',
    Lower_price_on_other_APP: '他のAPPがもっと安い',
    Low_quality_hotel: 'ホテルはよくない',
    Book_at_a_lower_price: 'カウンターで予約すると、もっと安い',
    Other: '他の',
    Please_write_your_reason: '原因をご入力ください\n',
    After_cancellation_done: '予約取消成功になりましたら、料金は３稼働日以内に返金します',
    How_to_fill_in_the_guest_name: '宿泊人は説明をご入力ください',
    It_should_be_exactly_the_same: 'ホテル予約する時、必ず宿泊人の名前をご入力ください。アルファベットでご入力ください。チェックインする時の証明書と一致しなければなりません',
    How_to_fill_in_a_Chinese_name: '中国名前の入力方法：',
    How_to_fill_in_a_English_name: '英名の入力方法：',
    For_example: '例えば：“韩梅梅”、姓は“Han”、名は“Meimei”',
    No_specical_characters: '英名には数字と特殊文字が含まれません',
    Name_rule_first: '姓は前、名は後。もし中間名がある場合、一字空けて名の後でご入力ください',
    Name_rule_second: '',
    Details: '明細',
    Pay_now: 'すぐ支払',
    Hotel: 'ホテル',
    Check_in: 'チェックイン',
    Car: 'レンタカー',
    All_bookings: '全ての予約',
    All: '全部',
    the_real_scene: '写真は参考用です、実際のホテルの滞在を参照してください',
    COUPON_TXT: 'クーポン',
    SHEET: '枚',
    NONE_USE_TEXT: '無し',
    USE_COUPON: '優待券利用',
    BINDING_COUPON: '追加',
    DESELECT_COUPON: '优惠劵取消して優待券を選択して下さい',
    AVAILABLE: '使用可能',
    NO_COUPON_AVALIABLE: '使用可能のクーポン券がありません。',
    UNAVAILABLE: '使用不可',
    NOT_ACTIVE: '効力発生前',
    COUPON_TO_BINDING: '優待券との紐付け',
    WRITE_PREFERETIAL_CODE: '優待券コードを入力して下さい',
    BINDING_USE: 'パウンドして使用',
    HAS_DEDUCTED_BEFORE: '',
    HAS_DEDUCTED_AFTER: '引き',

    NAME_TXT: 'お名前',
    HOLDER_NAME: 'カードに記載された名前',
    EXPIRATION_DATE: '有効期限',
    FORMAT_TXT: 'フォーマット',
    SECURITY_CODE: 'セキュリティコード',
    MASTER_CARD_NAME: 'Master Card',
    JCB_CARD_NAME: 'JCB',
    DIGITS_ON_BACK_OF_CARD: 'カードの裏面に記載されている3桁の番号',
    AMERICAN_EXPRESS_NAME: 'American Express',
    FOUR_CAR_NUM_TIPS: 'カード表面の４桁の数字',
    ENTER_COMPLETE_CARD_NUM: 'カード番号を入力',
    PLEASE_ENTER_HOLDER_NAME: 'カードに記載された名前を入力',
    ENTER_SECURITY_CODE: 'セキュリティコードを入力',
    ENTER_EXPIRATION_DATE: '有効期限を入力',
    ROOM_DETAILS: '客室の詳細',
    CONDITION_CANCEL: 'キャンセルについて',
    CHOOSE_PAYMENT_METHOD: 'お支払い方法の選択',
    ORDER_TOTAL_LUMP: '総額',
    CREDIT_CARD_NUM: 'デビットカード/クレジットカード番号',
    MAINLAND_CARD_ONLY: '中国大陸以外で発行された銀行カードのみ',
    SHUT_DOWN: '閉じる',

    SELECT_COUNTRY_CODE: '国家または地域を選択してください',
    HOT_COUNTRY_OR_AREA: '最も選択された',
    EVAL_LIST_NO_DATA: 'データがありません',


    // 酒店搜索改版新增翻译
    PREFIX_ROOMS: '',
    SUFFIX_ROOM: 'Room',       // 单数
    SUFFIX_ROOMS: 'Rooms',     // 复数
    PREFIX_ADULTS: '',
    SUFFIX_ADULT: 'Adult',
    SUFFIX_ADULTS: 'Adults',
    PREFIX_CHILDREN: '',
    SUFFIX_CHILD: 'Child',
    SUFFIX_CHILDREN: 'Children',
    ROOM: 'Room',
    AGE: 'year old',
    AGES: 'years old',
    SELECT_ROOMS_TIPS: 'Please include each Child\'s age so we can find you the best room and bed configuration.',
    CHECK_IN_DETAIL: 'Guest details',
    CHILD_AGE: 'Child\'s Age',
    FILTER_CONDITION: 'Your Selection:',
    NO_MATCH_TIPS: 'The below room type does not match the number of rooms and guests you selected.',
    ROOM_COUNT: 'Rooms',
    GUESTS: 'Guests',
    NO_MATCH_HOTEL: 'Below are hotels that do not match your selections.',
    TAXES_INCL: '税金込み',
    BOOK_TIMEOUT_TIPS: 'このページは有効期限を切れてますので、前のページに戻って予約をお願い申し上げます。料金および利用状況は変動する可能性もあり、ご了承ください。',
    LIST: 'リスト',
    RENT_CAR_BOOK: '予約',
    HOTEL_STR: '詳細',
    SETTLEMENT_DETAIL: '宿泊者詳細',
    CONTACT_NAME: '連絡者氏名',
    COUNTRY_CODE: '國コード',
    PHONE_NUMBER: '携帯番号',
    TRAVEL_PHONE_NUMBER: '名前を入力してください',
    PLEASE_SELECT_AREA_CODE: '國コードを選んてください',
    PERSON_COUNT: 'Guests',

    Search: '搜索',
    COST_DESCRIPTION: '料金について',
    TOTAL: '合計',
    SEE_ORDER_INFO_TO: 'お支払い',
    KONW: '了解',
    BOOKING_INFORMATION: '注意事項',
    Book_Now: 'すぐ支払ます',
    MAP: '地図',
    CONTACT_INFORMATION: '連絡先',
    LOADING: 'ロード中...',
    SORT_FILTER: '並べ替え/選別',
    SCREENING: '検索条件',
    SEQUENCE: '並べ替え',
    PHONE_ASK: '電話でお問い合わせ',
    ABOVE: 'より',
    SUBMINT_ORDER: '申込提出',
    OK: '確定',
    Order_detail: '予約詳細',
    BOOKING_INFO: '予約明細',
    PAYMENT_AMOUNT: '予約料金',
    Order_time: '予約日時',
    ORDER_NUMBERS: '予約番号',
    PAY_TYPE: 'お支払い方法',
    BALANCE: '残高',
    CURRENT_BALANCE_BEGIN: 'バランス',
    OVERPLUS_BALANCE_BEGIN: '残金',
    OTHER_PAYMENT: '他のお支払い方法',
    Unionpay: 'UnionPay',
    Wechatpay: 'WeChat Payment',
    Alipay: 'Alipay',
    AGREE_SERVICE_AGREEMENT_BEFORE: '「すぐ支払ます」をクリックすれば、本社の',
    AGREE_SERVICE_AGREEMENT_AFTER: 'を同意です',
    SERVICE_AGREEMENT: '《服务协议》',
    PAYMENT_ORDER: '予約をお払い',
    Total_pay: '請求金額',
    PAY_SUCCESS: '支払成功',
    CHECK_THE_ORDER: '予約をチェックします',
    BACK_TO_INDEX: 'ホームページへ戻す',
    CANCEL: 'キャンセル',
    RECOMMED: '人気度',
    PRICE: '料金',
    HIGH: '高い',
    LOW: '低い',
    RESET: 'リセット',
    SELECT_TIME: '日付設定',
    Hotel_guest: '宿泊する人',
    Select: '選択して下さい',
    Emial_address: 'メールアドレスを入力して下さい',
    Booking_explan: '予約注意事項',
    VIEW_MORE: 'もっと情報を見る',
    COLLAPSE: '閉じる',
    Week: '',
    Month: '',
    TOURISM_CHECK_IN_HOTEL: 'チェックイン',
    TOURISM_LEAVE_HOTEL: 'チェックアウト',
    SUBMIT: '送信する',
    EMAIL: 'メールアドレス',
    BOOK_FAIL: '予約失敗',
    BOOK_FAIL_DETAIL: 'また、ご予約失敗しました。やり直して下さい。',
    RESET_BOOK: 'やり直します',
    ROOM_TYPE_LOADING_TIPS: '部屋タイプ検索中、暫くお待ちください……',
    NEARBY_HOTEL: '周辺のホテル',
    HOT_CITY: '人気目的地',

    SEARCH_HISTORY: '検索歴史',
    BREAKFAST_INCLUDE: '食付き',
    BREAKFAST_EXCLUDE: '食無し',
    DOUBLE_BED: 'シングルベット',
    TWIN_BED: 'ダブルベット',
    FREE_CANCEL: '無料キャンセル',
    MEALS: '食事',
    EVALUATION: 'コメント',
    FEATURED_REVIEWS: '良いコメント',
    ALL_REVIEWS: '全部コメント',
    OVERALL_EVALUATION: '全体評価',
    ANONYMOUS: '匿名',
    EVAL_GENERAL_LIST_1: '悪い',
    EVAL_GENERAL_LIST_2: '良くない',
    EVAL_GENERAL_LIST_3: '一般',
    EVAL_GENERAL_LIST_4: '良い',
    EVAL_GENERAL_LIST_5: '非常に良い',
    MAX_IMAGES_WITH_NINE: '最大9枚の画像が選びます',
    GRADE_EVAL: '全体評価を選択して下さい',
    DISTANCE_FILTER: '距離　近い→遠い',
    EDIT_EVALUATION: '口コミ投稿',
    GO_TO_EVAL: '口コミ投稿',
    EVAL_POINTS_AWARD: '最大1000ポイントが貯まる（1000ポイント＝CNY10元相当で使える）！',
    NEARBY_LIKE_HOTEL: '周辺の似た条件のホテル',
    DISTANCE_HOTEL: 'アクセス',
    PLEASE_ENTER_COMMENT: '口コミを記入ください',
    AWARD_POINTS_TIPS: '口コミ投稿で最大1000ポイントが貯まる（1000ポイント＝CNY10元相当で使える）！',
    NO_SHOW_ANONYMOUS_AVATAR: '匿名で口コミを記入する場合はユーザーネームとアカウント画像が表示されません',
    LOCATION: 'アクセス',
    FACILITY: '設備',
    SERVICE: 'サービス',
    HEALTH: '清潔度',
    LANGUAGE_SELECT: '表示言語を選択',
    LIMIT_COMMENT_TXT: 'コメントは 5~2000 文字以内にして下さい',
    COLLECTED_SUCCEED: 'コレクション成功！',
    CANCEL_COLLECT: 'コレクションを取り消しました。',

    PAY_TEXT1:'支払いがタイムアウトしました。新しく注文してください',
    PAY_TEXT2:'残高',
    PAY_TEXT3:'残り残高',
    PAY_TEXT4:'未アクティベート',
    PAY_TEXT5:'追加決済手数料',
    PAY_TEXT6:'もっと',
    PAY_TEXT7:'「今すぐ支払う」をクリックすることで、BaiGolfの規約に同意したものとみなされます',
    PAY_TEXT8:'サービス契約',
    PAY_TEXT9:'部屋料金',
    PAY_TEXT10:'連絡担当者',
    PAY_TEXT11:'連絡先電話番号',
    PAY_TEXT12:'情報を記入',
    PAY_TEXT13:'中国本土以外で発行されたクレジットカードのみ対応',
    PAY_TEXT14:'クレジットカード決済',
    PAY_TEXT15:'その他の決済方法',
    PAY_TEXT16:'決済方法を選択してください',
    PAY_TEXT17:'この決済方法を使用すると人民元で請求されます',
    PAY_TEXT18:'この決済方法を使用してもよろしいですか',
    PAY_TEXT19:'決済失敗',
  },
  WX_SHARED: {
    DETAIL_TITLE: '|ホテル予約',
    COMMON_TITLE: 'ホテル検索/アジアの数万のホテルオンライン予約',
    SUB_TITLE: 'BaiGolfでは、豊富なアジアホテルをオンラインで低価格でご予約いただけます。',
  },
};



// WEBPACK FOOTER //
// ./src/lang/ja_jp.js